import {
  AfterViewInit,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, AfterViewInit {
  @ViewChildren('menuItem1') menuItem1: QueryList<HTMLAnchorElement>;
  @ViewChildren('menuItem2') menuItem2: QueryList<HTMLAnchorElement>;
  private topBar;
  constructor(private router: Router) {}

  private nextLevel(elm: any, menuItem: any[], offset: string, topBar) {
    elm.addEventListener('click', function (e) {
      e.stopPropagation();
      menuItem.forEach((element: any) => {
        element.classList.remove('moved');
      });

      this.classList.add('moved');
      topBar.style.right = offset;
    });
  }

  private prevLevel(back: any, elm: any, offset: string, topBar) {
    back.addEventListener('click', (e) => {
      e.stopPropagation();
      // e.preventDefault();

      elm.classList.remove('moved');
      topBar.style.right = offset;
    });
  }

  ngAfterViewInit(): void {
    this.topBar = document.getElementsByClassName('top-bar-section')[0];

    this.menuItem1.forEach((elm: any) => {
      this.nextLevel(
        elm.nativeElement,
        this.menuItem1.map((m: any) => m.nativeElement),
        '-100%',
        this.topBar
      );
      const back = elm.nativeElement.querySelector('.dropdown > li.back');
      this.prevLevel(back, elm.nativeElement, '0', this.topBar);
    });
    this.menuItem2.forEach((elm: any) => {
      this.nextLevel(
        elm.nativeElement,
        this.menuItem2.map((m: any) => m.nativeElement),
        '-200%',
        this.topBar
      );
      const back = elm.nativeElement
        .querySelector('.dropdown > li.back')
        .querySelector('a');

      this.prevLevel(back, elm.nativeElement, '-100%', this.topBar);
    });

    const menuItems = document.querySelectorAll('li.show-for-medium-up');
    const closeOtherMegaMenu = function () {
      menuItems.forEach((element: any) => {
        const [link, megaMenuContainer] = element.children;
        link.classList.remove('open');
        link.setAttribute('aria-expanded', 'false');
        megaMenuContainer.classList.remove('open');
        megaMenuContainer.setAttribute('aria-hidden', 'true');
      });
    };
    menuItems.forEach((item) => {
      item.addEventListener('mouseenter', function () {
        closeOtherMegaMenu();

        const [link, megaMenuContainer] = this.children;
        link.setAttribute('aria-expanded', 'true');
        link.classList.add('open');

        megaMenuContainer.classList.add('open');
        megaMenuContainer.setAttribute('aria-hidden', 'false');
      });

      item.addEventListener('mouseleave', function () {
        closeOtherMegaMenu();
      });
    });

    window.addEventListener('scroll', function (event) {
      const [header] = this.document.body.getElementsByTagName('header') as any;
      if (this.scrollY > 0) {
        header.classList.add('fix-it');
      } else {
        header.classList.remove('fix-it');
      }
    });
  }

  menuOpen = false;
  toggleMenu() {
    const menu = document.querySelector('nav.top-bar');
    const body = document.body;

    if (this.menuOpen) {
      body.classList.remove('menu-opened');
      menu.classList.remove('expanded');
    } else {
      body.classList.add('menu-opened');
      menu.classList.add('expanded');
    }

    this.menuOpen = !this.menuOpen;
  }

  ngOnInit(): void {}
}
